module.exports = __webpack_public_path__ + "static/media/ship.0965b813.svg";